import Buttons from './src/buttons-vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpButtons = withInstall(Buttons)
export default EpButtons
export * from './src/buttons'
